<template>
  <div>
    <h2 class="text-center">Sổ tiền mặt</h2>
    <table class="mx-auto table-border">
      <thead>
        <tr>
          <th class="text-center text-no-wrap">Số thứ tự</th>
          <th class="text-center text-no-wrap">Số chứng từ</th>
          <th class="text-center">Ngày</th>
          <th class="text-center">Số tiền thu</th>
          <th class="text-center">Số tiền chi</th>
          <th class="text-center">Số dư</th>
          <th class="text-center">Số dư cộng dồn</th>
          <th class="text-center">Nội dung chi tiết</th>
          <th class="text-center">Số phòng</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="item._id">
          <td class="text-center text-no-wrap">
            {{ index + 1 }}
          </td>
          <td class="text-center text-no-wrap">{{ item.receipt_id }}</td>
          <td class="text-center text-no-wrap">
            {{ item.date_action | formatTimeServer }}
          </td>
          <td class="text-center text-no-wrap">
            {{ item.collected_amount || item.deposit_amount | formatCurrency }}
          </td>
          <td class="text-center text-no-wrap">
            {{ item.amount | formatCurrency }}
          </td>
          <td class="text-center text-no-wrap">
            {{ item.balance | formatCurrency }}
          </td>
          <td class="text-center text-no-wrap">
            {{
              item.accumulated_balance | formatCurrency
            }}
          </td>
          <td class="text-center text-no-wrap">
            {{ item.note }}
          </td>
          <td class="text-center text-no-wrap">
            {{ item.room_id }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "print-so-tien-mat",
  props: {
    items: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
};
</script>

<style></style>
